/**
 * Product card swatch color component
 *
 * @module product-card-swatch-color
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'product-card-swatch-color';

if(!customElements.get(customElements.component)) {

    class productCard extends HTMLElement {

        /**
         * Web component constructor
         *
         * @constructor
         */
        constructor() {

            super();


            window.theme.product.loadProduct(this.dataset.handle, true).then(product => {
                this.render(product);
                this.initEvents(product);
            });

            this.addToShowroomBtn = this.closest(".product-grid__item")?.querySelector(".js-add-to-showroom-btn");
        }

        /**
         * Render component in the DOM
         *
         * @param {object} product Product data.
         * @returns {undefined}
         */
        render(product) {
            if(product.options.length) {
                (product.options).forEach(option => {
                    if((option.name).toLowerCase() == "color") {
                        let html =  "";
                        this.options = option.values;

                        let path = window.location.pathname.split("/").pop();

                        // check if is sales page
                        let isSales = false;
                        if (path == "sale" || path == "sales") {
                            isSales = true;
                        }

                        if(option.values.length > 1) {
                            (option.values).forEach((value, index) => {
                                if (index < 5 ) {
                                    let isSalesOption = false;

                                    if (isSales) {
                                        // find first variant with swatch name
                                        let variant = (product.variants).find(variant => {
                                            return variant.title.toLowerCase().includes(value.toLowerCase());
                                        });

                                        if (variant.compare_at_price) {
                                            isSalesOption = true;
                                        }
                                    }

                                    if ((!isSales || isSales && isSalesOption)) {
                                        let handle_color_value = window.theme.handleize(value);
                                        let swatchObj = (window.theme.hex_swatches.colors.find( item => {return item.handle_title == handle_color_value})) || "";

                                        if (swatchObj && swatchObj !== "") {
                                            const colorName = swatchObj.handle_title ? swatchObj.handle_title.toUpperCase().replaceAll("-", " ") : value;
                                            let buttonClass = "product-card__color-swatch block w-4 h-4 border-x border-y border-solid border-grey mr-2";
                                            if (index === 0) buttonClass += " active";
                                            let ariaLabel = swatchObj.handle_title || value;
                                            let dataAttr = swatchObj.handle_title || value;

                                            if (index === 0) {
                                                this.addToShowroomBtn && this.addToShowroomBtn.setAttribute("data-color-name", colorName);
                                            }

                                            if (swatchObj.image) {
                                                html += `<button aria-label="${ariaLabel}" data-product-card-swatch="${dataAttr}" class="${buttonClass}" style="padding:0;background:none;">
                                                    <span class="block w-full h-full overflow-hidden">
                                                        <img src="${swatchObj.image}" alt="${ariaLabel}" class="object-cover w-full h-full" />
                                                    </span>
                                                </button>`;
                                            } else {
                                                html += `<button aria-label="${ariaLabel}" data-product-card-swatch="${dataAttr}" class="${buttonClass}" style="background-color: ${swatchObj.color};"></button>`;
                                            }
                                        } else {
                                            let buttonClass = "product-card__color-swatch block w-4 h-4 border-x border-y border-solid border-grey mr-2";
                                            let dataAttr = swatchObj.handle_title || value;

                                            html += `<button aria-label="${dataAttr}" data-product-card-swatch="${window.theme.handleize(dataAttr)}" class="${buttonClass}" style="background-color: #ffffff;"></button>`;
                                        }
                                    }
                                } else if (index == 5) {
                                    html += `<span class="text-[10px]">+ ${option.values.length - 5} Color(s)</span>`;
                                }
                            });

                            this.innerHTML = html;
                        }
                    }
                });
            }
        }

        /**
         * Init events
         *
         * @param {object} product Product data.
         * @returns {undefined}
         */
        initEvents(product) {
            this.querySelectorAll("[data-product-card-swatch]").forEach(swatch => {
                const colorHandle = swatch.dataset.productCardSwatch;
                let images = [];

                if(colorHandle) {

                    (product.images).forEach(image => {
                        if (image.alt) {
                            let alt = image.alt.toLowerCase();
                            if (alt.includes('swatch')) return;

                            let altArray = alt.split('/');
                            let reference = (altArray[1]) ? altArray.slice(1).join('/').trim() : null;
                            if (!reference) return;

                            const refHandle = window.theme.handleize(reference);
                            if (refHandle === colorHandle) {
                                images.push(image);
                            }
                        }
                    });

                    if (images.length > 2) {
                        images = images.slice(0, 2);
                    }

                    if(images.length > 0) {
                        swatch.addEventListener("click", () => {
                            this.activeSwatch(swatch, product, images);
                            this.changePrice(product, swatch.dataset.productCardSwatch);
                        });
                    }

                }

            });
        }

        /**
         * Get image alt from current variant active.
         * 
         * @param {object} product Product data.
         * @param {object} variant Variant data.
         * @returns {string} Image alt.
        */
        getCurrentAlt(product, variant) {

            let currentAlt = null;

            if(product.images) {
            
                product.images.forEach(image => {

                    if(image.alt && variant) {

                        let alt       = image.alt.toLowerCase(),
                            altArray  = alt.split('/'),
                            reference = (altArray[1]) ? altArray[1].trim() : null;

                        if( altArray.length > 2 ){
                            altArray.shift();
                            reference = altArray.join('/');
                        }

                        if(variant.title.toLowerCase().includes(reference) && !alt.includes('swatch')) {
                            currentAlt = alt;
                        }
                    }
                });

                return currentAlt;
            } 
        }

        /**
         * active Swatch
         *
         * @param {object} swatch Swatch data.
         * @param {object} product Product data.
         * @returns {undefined}
         */
        activeSwatch(swatch, product, images) {
            let image_src = images[1].src,
                ext = window.theme.file.getExtension(image_src);

            image_src = image_src.replace(new RegExp(ext), '_600x900_crop_center' + ext);
            document.querySelector("[data-product-card-image-hover='" + product.handle + "'] img").src = image_src;

            if(images[1]) {
                let image_hover_src = images[0].src,
                    image_hover_ext = window.theme.file.getExtension(image_hover_src);

                image_hover_src = image_hover_src.replace(new RegExp(image_hover_ext), '_600x900_crop_center' + image_hover_ext);

                document.querySelector("[data-product-card-image='" + product.handle + "'] img").src = image_hover_src;
            } else {
                document.querySelector("[data-product-card-image='" + product.handle + "'] img").src = image_src;
            }

            this.querySelectorAll("[data-product-card-swatch]").forEach(swatch => {
                swatch.classList.remove("active");
            });

            swatch.classList.add("active");

            const colorName = swatch.dataset.productCardSwatch.toUpperCase().replaceAll("-", " ");

            this.addToShowroomBtn && this.addToShowroomBtn.setAttribute("data-color-name", colorName);
        }

        /**
         * change price
         *
         * @param {string} swatch Swatch name.
         * @param {object} product Product data.
         * @returns {undefined}
         */
        changePrice(product, swatch) {
            let priceComponent = document.querySelector("price-component[data-handle='" + product.handle + "']");

            // find first variant with swatch name
            let variant = (product.variants).find(variant => {
                return variant.title.toLowerCase().includes(swatch.toLowerCase());
            });

            if (priceComponent && variant) {
                const priceEl = priceComponent.querySelector("[data-price]");
                const compareAtPriceEl = priceComponent.querySelector("[data-compareatprice]");

                priceEl.innerHTML = window.theme.money.format(variant.price);

                if (compareAtPriceEl) {
                    if (variant.compare_at_price) {
                        compareAtPriceEl.innerHTML = window.theme.money.format(variant.compare_at_price);
                    } else {
                        compareAtPriceEl.innerHTML = " ";
                    }
                }
            }
        }


    }

    customElements.define(customElements.component, productCard);
}
